var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingBagHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1543 27.3333H6.07096C3.62096 27.3333 1.52096 25.4083 1.4043 22.9583L0.529297 7.5H22.696L21.7626 22.9583C21.646 25.4083 19.6043 27.3333 17.1543 27.3333Z",
    fill: "#658479",
    stroke: "#121212",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.94629 13.3333V5.16667C6.94629 2.6 9.04629 0.5 11.613 0.5C14.1796 0.5 16.2796 2.6 16.2796 5.16667V13.3333",
    stroke: "#121212",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBagHover);
export default __webpack_public_path__ + "static/media/Shopping_bag-hover.6fb66ae90ad48d62b4c73d3b257cb210.svg";
export { ForwardRef as ReactComponent };